// import axios from 'axios';
import moment from 'moment';
import { useToast } from 'vue-toastification';

import ApiService from '../services/api';

import { mapState, mapWritableState, mapActions } from 'pinia';
import { useMainStore } from '../stores/main';

export default {
  data: () => {
    return {
      api_url: null,
      api: null,

      // loading: false,
      loading_count: 0,
      toast: null,
    };
  },

  created: function () {
    this.post_types = {
      post: {
        label: 'Magazine',
        labelPlural: 'Magazine',
        actionLabel: "Leggi l'articolo",
        features: [],
      },
      activity: {
        label: 'Attività',
        labelPlural: 'Attività',
        actionLabel: 'Vedi attività',
        features: [],
      },
      contest: {
        label: 'Concorso',
        labelPlural: 'Concorsi',
        actionLabel: 'Vai al concorso',
        features: ['cta'],
      },
      event: {
        label: 'Evento',
        labelPlural: 'Eventi',
        actionLabel: "Vai all'evento",
        features: ['attendees_icon', 'location_badge', 'date_badge'],
      },
      kit: {
        label: 'Kit educativo',
        labelPlural: 'Kit educativi',
        actionLabel: 'Mostra il kit',
        features: ['rating', 'requested_icon', 'cta'],
      },
      pcto: {
        label: 'PCTO',
        labelPlural: 'PCTO',
        actionLabel: 'Vai al PCTO',
        features: [],
      },
      poll: {
        label: 'Sondaggio',
        labelPlural: 'Sondaggi',
        actionLabel: 'Vai al sondaggio',
        features: ['poll_box'],
      },
      room: {
        label: 'Stanza',
        labelPlural: 'Stanze',
        actionLabel: 'Vai alla stanza',
        features: ['no_bookmark'],
      },
      story: {
        label: 'Storie',
        labelPlural: 'Storie',
        actionLabel: 'Leggi la storia',
        features: ['collection_badge'],
      },
      webinar: {
        label: 'Webinar',
        labelPlural: 'Webinar',
        actionLabel: 'Vai al webinar',
        features: ['location_badge', 'date_badge', 'attendees_icon', 'cta'],
      },
    };
  },

  mounted: function () {
    var self = this;

    /*
		if( window.communiti_api_base_url != undefined )
			this.api_url = window.communiti_api_base_url;

		let axios_config = {
			baseURL: this.api_url,
			timeout: 30000,
		};

		if( window.communiti_nonce )
			axios_config.headers = { ...axios_config.headers, 'X-WP-Nonce': window.communiti_nonce }


        this.api =  axios.create(axios_config);
		*/
    var api_service = new ApiService();
    this.api = api_service.client;

    this.toast = useToast();
  },

  methods: {
    getPostTypeMeta: function (type) {
      return this.post_types[type] ?? this.post_types['post'];
    },

    setLoading: function (status) {
      if (status) this.loading_count++;
      else this.loading_count--;

      return this.loading_count == 0;
    },
    optionsObjectToArray: function (obj) {
      var arr = [];
      for (var i in obj) {
        arr.push({
          key: i,
          value: obj[i],
        });
      }
      return arr;
    },

    isEmailValid: function (email) {
      return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
    },

    getRandomInt: function(max) {
      return Math.floor(Math.random() * max);
    },

    getRandomColor: function(){
      
        var o = Math.round, r = Math.random, s = 255;
        return 'rgb(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ')';
    
    },

    assetUrl: function (path) {
      return (
        (window.communiti_assets_base_url
          ? window.communiti_assets_base_url
          : '') + path
      );
    },

    formatDate: function (dt) {
      return moment(dt).format('DD/MM/YYYY');
    },

    formatDateTime: function (dt) {
      return moment(dt).format('DD/MM/YYYY HH:mm:ss');
    },

    humanFileSize: function (bytes, si = false, dp = 1) {
      const thresh = si ? 1000 : 1024;

      if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
      }

      const units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
      let u = -1;
      const r = 10 ** dp;

      do {
        bytes /= thresh;
        ++u;
      } while (
        Math.round(Math.abs(bytes) * r) / r >= thresh &&
        u < units.length - 1
      );

      return bytes.toFixed(dp) + ' ' + units[u];
    },

    getHashedNumber: function (str, num, mod) {
      return parseInt((parseInt(str, 36) / 10000 + parseInt(num)) % mod) + 16;
    },

    getUserActivity: function () {
      console.log('getUserActivity');
    },

    uploadMedia: function (
      selected_image,
      callback = () => {},
      callback_error = false,
      callback_finally = false,
      delete_media_id = false
    ) {
      const self = this;

      self.setLoading(true);
      this.api
        .post(
          'media/upload',
          { image: selected_image, delete_media: delete_media_id },
          {
            headers: { 'Content-Type': 'multipart/form-data' },
          }
        )
        .then((response) => {
          if (response.data.success) {
            self.toast.success('Immagine caricata correttamente');

            callback(response);
          } else {
            throw new Error(response.data.message);
          }
        })
        .catch((error) => {
          if (callback_error) {
            callback_error(error);
          } else {
            self.toast.error('Errore nel caricamento dell\'immagine');
          }
          
          console.log(error);
        })
        .finally(() => {
          self.setLoading(false);

          if (callback_finally) {
            callback_finally();
          }
        });
    },

    updateDeskUser: function () {
      const self = this;

      console.log('updateDeskUser');

      // la chiamata viene fatta a WP, che poi la inoltra via guzzle al backend
      this.api
        .get('users/deskUpdate')
        .then((response) => {
          if (response.data.success) {
            self.posts = response.data.posts;
          } else {
            // self.toast.error(response.data.message);
          }
        })
        .catch((error) => {
          //self.toast.error('Errore nella richiesta');
          console.log('Error updateDeskUser:', error);
        });
    },

    dispatchUserEvent: function( post_data ){
      this.api.post('user-event/dispatch', post_data)
        .then((response) => {

          if (!response.data.success) {
            self.toast.error(response.data.message);
          }

        })
        .catch((error) => {
          self.toast.error('Errore nella richiesta');
        })
        .finally(() => self.setLoading(false))
    },

    ...mapActions(useMainStore, [
      'setAppReady',
      'setUserActivity',
      'setUser',
      'setCommentablePost',
      'setWallFilter',
      'setOverlay',
    ]),
  },

  computed: {
    ...mapState(useMainStore, ['app_ready', 'user_activity', 'user', 'config', 'wall_filter', 'overlay']),
    ...mapWritableState(useMainStore, ['commentable_post']),

    loading: function () {
      return this.loading_count > 0;
    },
  },
};
